import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_META_INTERFACE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDMetaInterfaceState extends EntityState<IID_META_INTERFACE, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_META_INTERFACE })
export class IIDMetaInterfaceStore extends EntityStore<IIDMetaInterfaceState> {
  constructor() {
    super([]);
  }
}
